module.exports = __webpack_public_path__ + "static/media/edit-program.888499c9.svg";